"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonaInitialsColor = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./Persona"), exports);
tslib_1.__exportStar(require("./Persona.base"), exports);
tslib_1.__exportStar(require("./Persona.types"), exports);
tslib_1.__exportStar(require("./PersonaCoin/index"), exports);
tslib_1.__exportStar(require("./PersonaConsts"), exports);
// Exporting in case someone would like to track the current color of a persona
var PersonaInitialsColor_1 = require("./PersonaInitialsColor");
Object.defineProperty(exports, "getPersonaInitialsColor", { enumerable: true, get: function () { return PersonaInitialsColor_1.getPersonaInitialsColor; } });
//# sourceMappingURL=index.js.map